import { css } from 'styled-components';

export const knobStyles = css`
    border-style: solid;
    box-sizing: border-box;
    background: ${({ theme: { colorPicker: { colors: { knob } } } }) => knob.backgroundColor};
    border-width: ${({ theme: { colorPicker: { composites: { knob } } } }) => knob.borderWidth}; 
    border-color: ${({ theme: { colorPicker: { colors: { knob } } } }) => knob.borderColor};
    border-radius: ${({ theme: { colorPicker: { composites: { knob } } } }) => knob.borderRadius};
    box-shadow: ${({ theme: { colorPicker: { composites: { knob } } } }) => knob.boxShadow};
`;

export const pickerSurfaceStyles = css`
    border-style: solid;
    box-sizing: border-box;
    border-width: ${({ theme: { colorPicker: { composites: { pickerSurface } } } }) => pickerSurface.borderWidth}; 
    border-color: ${({ theme: { colorPicker: { colors } } }) => colors.pickerSurfaceBorderColor};
    border-radius: ${({ theme: { colorPicker: { composites: { pickerSurface } } } }) => pickerSurface.borderRadius};
    box-shadow: ${({ theme: { colorPicker: { composites: { pickerSurface } } } }) => pickerSurface.boxShadow};
`;
